import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { NuevoUsuario } from "../models/nuevo-usuario";
import { Observable } from "rxjs";
import { LoginUsuario } from "../models/login-usuario";
import { JwtDTO } from "../models/jwt-dto";
import { environment } from "../../../environments/environment";
import { endpointsURL } from "src/app/constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  env = environment.env;
  authURL = endpointsURL.authURL;

  constructor(private httpClient: HttpClient) {}

  public nuevo(nuevoUsuario: NuevoUsuario): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.authURL}nuevo`,
      nuevoUsuario
    );
  }

  public login(loginUsuario: LoginUsuario): Observable<JwtDTO> {
    return this.httpClient.post<JwtDTO>(
      `${this.env}${this.authURL}login`,
      loginUsuario
    );
  }

  public refresh(dto: JwtDTO): Observable<JwtDTO> {
    return this.httpClient.post<JwtDTO>(
      `${this.env}${this.authURL}refresh`,
      dto
    );
  }

  public logout(dto: JwtDTO): Observable<any> {
    return this.httpClient.post<any>(`${this.env}${this.authURL}logout`, dto);
  }
}
